
<div v-if="memoryUsage" class="memory-usage">
    <div class="text-center">
        {{ memoryUsage }}
    </div>
    <div class="v-flex">
        <div class="primary memory-bar" :style="'height:' + this.usedInPercent + '%'" >

        </div>
        <div class="background-selected memory-bar" :style="'height:' + (100 - this.usedInPercent) + '%'">

        </div>
    </div>
</div>
